import EmphasizedContent from '@blocks/EmphasizedContent'
import { useSalonContext } from '@customer/components/pages/Salon/context'
import UnexpectedSalonTypeError from '@errors/UnexpectedSalonTypeError'
import React from 'react'
import SalonUnavailableFinished from './components/SalonUnavailableFinished'
import SalonUnavailableFuture from './components/SalonUnavailableFuture'
import SalonUnavailableVoting from './components/SalonUnavailableVoting'

export default function SalonUnavailable() {
    const { salon } = useSalonContext()

    switch (salon.state.type) {
        case "voting":
            return <SalonUnavailableVoting />
        case "finished":
            return <SalonUnavailableFinished />
        case "future":
            return <SalonUnavailableFuture />
        default:
            throw new UnexpectedSalonTypeError(salon.state.type)
    }
}